"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SellOption = void 0;
var SellOption;
(function (SellOption) {
    SellOption["TicketOnly"] = "ticket_only";
    SellOption["VoucherOnly"] = "voucher_only";
    SellOption["TicketAndVoucher"] = "ticket_and_voucher";
})(SellOption = exports.SellOption || (exports.SellOption = {}));
//# sourceMappingURL=sellOption.js.map